import {useLang} from '@/context/LanguageContext';

export default function PressureVirtualValues({config, live}) {
  const {t, lang}=useLang();
  const samples=live?.samples || [];
  const current=samples.length>0 && samples.every(sample=>sample.config_version===config?.config_version);
  const reasons={
    disabled:t('Berekening uitgeschakeld','Calculation disabled'),
    inputs_not_simultaneous:t('Invoer niet gelijktijdig gemeten','Inputs not measured simultaneously'),
    missing_or_invalid_input:t('Wacht op geldige invoer','Waiting for valid inputs'),
    nonfinite_result:t('Geen geldige uitkomst','No valid result'),
    calculation_error:t('Berekening niet beschikbaar','Calculation unavailable'),
  };
  return (config?.virtual_channels || []).map(channel=>{
    const result=current ? live?.virtual?.[channel.channel_id] : null;
    const enabled=channel.enabled && config?.features?.virtual_channels!==false;
    const valid=enabled && result && !result.reason && Number.isFinite(result.value) && result.unit===channel.output_unit;
    const status=!enabled ? reasons.disabled : !current ? t('Wacht op actuele metingen','Waiting for current measurements') : valid ? t('Berekend','Calculated') : (reasons[result?.reason] || t('Wacht op geldige invoer','Waiting for valid inputs'));
    return <div key={channel.channel_id} data-testid={`pressure-virtual-${channel.channel_id}`} className="min-w-0 rounded-lg border border-border border-t-[3px] border-t-primary bg-card px-4 py-3">
      <div className="break-words text-sm text-muted-foreground">{channel.channel_id} · {channel.name}</div>
      <div className="my-2 break-words font-mono text-3xl font-semibold">{valid ? result.value.toLocaleString(lang,{maximumFractionDigits:2}) : '—'} <span className="text-base text-muted-foreground">{channel.output_unit}</span></div>
      <p className={`text-xs ${valid ? 'text-muted-foreground' : 'text-amber-600 dark:text-amber-400'}`}>{status}</p>
      {valid && result.assumptions?.length>0 && <p className="mt-2 text-xs text-muted-foreground">{t('Met ingestelde aannames','Uses configured assumptions')}</p>}
    </div>;
  });
}
